import {
  OFFLINE_DURATION_LOCALSTORAGE_KEY,
  SERVICE_NAME,
  UBA_EVENT_NAMES,
} from '../constants/Constants';
import {
  PROCTOR_FAILED_IMG_COUNTER_LOCALSTORAGE_KEY,
  PROCTOR_INITIATED_IMAGE_UPLOAD_LOCALSTORAGE_KEY,
  PROCTOR_SIGNED_URL_COUNTER_LOCALSTORAGE_KEY,
} from '../constants/Proctor';

// Initializing the UBA
export const initTracking = (mainParams = {}, keyNames = {}) => {
  const defaultKeyNames = {};
  window.tracking.init({ ...defaultKeyNames, ...keyNames }, mainParams);
};

// Generic function for events call
export const doTracking = ubaTrackingData => {
  const payload = { uba: ubaTrackingData };
  if (!ubaTrackingData) {
    payload.uba = {
      ...ubaTrackingData,
      keyNames: {
        // fftid: 'SRP'
      },
    };
  }

  window.tracking.doTracking(payload);
};

// example of one uba util function like pageView
export const pageView = (payload = {}, eventName) => {
  const trackingData = {
    eventName,
    keyNames: {
      actionType: 'Pageview',
      ...payload,
    },
  };
  doTracking(trackingData);
};

export const ctaClick = ({ payload = {}, eventName }) => {
  const trackingData = {
    eventName,
    keyNames: {
      actionType: 'click',
      ...payload,
    },
  };
  doTracking(trackingData);
};

export const getBandwidthData = trackingData => {
  let bandwidth = trackingData?.keyNames?.bandwidth || 'N/A';
  let networkSpeed = sessionStorage.getItem('image-internet-speed');
  networkSpeed = networkSpeed ? JSON.parse(networkSpeed) : {};
  if (networkSpeed.uploadSpeed || networkSpeed.downloadSpeed) {
    bandwidth = `Upload speed in mbps: ${networkSpeed.uploadSpeed ||
      'N/A'}, Download Speed in mbps: ${networkSpeed.downloadSpeed || 'N/A'}`;
  } else if (navigator?.connection) {
    bandwidth = navigator.connection.effectiveType;
  }
  return {
    bandwidth,
    uploadSpeed: networkSpeed.uploadSpeed || 'N/A',
    downloadSpeed: networkSpeed.downloadSpeed || 'N/A',
  };
};

// reuse UBA EVENT  and changes value of serviceName: desmond:<service name>
export const errorLogger = (error, payload = {}, bandwidth) => {
  const trackingData = {
    eventName: UBA_EVENT_NAMES.errorLog,
    keyNames: {
      errorMessage: error?.response?.data?.description || error?.message,
      errorSource: error?.config?.url || error?.errorSource,
      errorStatus: error?.response?.status || error?.name,
      userType: 'candidate',
      serviceName: SERVICE_NAME,
      payload: payload ? JSON.stringify(payload) : '',
    },
  };
  trackingData.keyNames.bandwidth =
    bandwidth || getBandwidthData(trackingData).bandwidth || 'N/A';
  doTracking(trackingData);
};

export const proctoringUBALogger = (verbose, label, keyNames) => {
  const trackingData = {
    eventName: UBA_EVENT_NAMES.proctoringLog,
    keyNames: {
      ...keyNames,
      actionType: 'view',
      label,
      userType: 'candidate',
      verbose,
    },
  };
  trackingData.keyNames.bandwidth =
    getBandwidthData(trackingData).bandwidth || 'N/A';
  doTracking(trackingData);
};

export const proctoringUBATracker = ({ keyNames, additionalInfo }) => {
  const bandwidthData = getBandwidthData();
  const trackingData = {
    eventName: UBA_EVENT_NAMES.proctoringTracker,
    keyNames: {
      ...keyNames,
      actionType: 'heartbeat',
      userType: 'candidate',
      uploadSpeed: bandwidthData.uploadSpeed || 'N/A',
      downloadSpeed: bandwidthData.downloadSpeed || 'N/A',
      offlineDuration:
        localStorage.getItem(OFFLINE_DURATION_LOCALSTORAGE_KEY) || 'N/A',
      failedImageUploadsCount:
        localStorage.getItem(PROCTOR_FAILED_IMG_COUNTER_LOCALSTORAGE_KEY) ||
        'N/A',
      initiatedSignedUrlCount:
        localStorage.getItem(PROCTOR_SIGNED_URL_COUNTER_LOCALSTORAGE_KEY) ||
        'N/A',
      additionalInfo: `${additionalInfo ||
        ''} initiated Image upload: ${localStorage.getItem(
        PROCTOR_INITIATED_IMAGE_UPLOAD_LOCALSTORAGE_KEY
      ) || 'N/A'}`,
      bandwidth: bandwidthData.bandwidth || 'N/A',
    },
  };
  doTracking(trackingData);
};

export const popUpView = ({ payload = {} }) => {
  const trackingData = {
    eventName: UBA_EVENT_NAMES.popUpView,
    keyNames: {
      actionType: 'view',
      ...payload,
    },
  };
  doTracking(trackingData);
};

export const popUpClick = ({ payload = {} }) => {
  const trackingData = {
    eventName: UBA_EVENT_NAMES.popUpClick,
    keyNames: {
      actionType: 'click',
      ...payload,
    },
  };
  doTracking(trackingData);
};

export const getEventName = eventType => {
  switch (eventType) {
    case 'click':
      return UBA_EVENT_NAMES.problemClick;
    case 'view':
      return 'DESMOND-VIEW';
    default:
      break;
  }
  return '';
};
